import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { AppinfoService } from './appinfo.service';
import { SettingsNinjaService } from './settings-ninja.service';

@Injectable()
export class ResolverNinjaInfoService implements Resolve<any> {

	constructor(
		private appinfoService: AppinfoService,
		private ninjaService: SettingsNinjaService
	) { }
	async resolve() {
		try {
			const info = await this.appinfoService.getCustomerAppInfoNinja();
			this.ninjaService.ninjaDefaults = info.defaults;
			const url = this.ninjaService.ninjaDefaults.mapServiceUrl;
			if (url) {
				await this.ninjaService.getNinjaLayers(url);
			}
		} catch (err) {
			console.log(err);
		}
		
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-ninja-info.service.ts